import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LoaderStateModel } from './loader.model';
import { LoaderHide, LoaderProgress, LoaderShow } from './loader.actions';

@State<LoaderStateModel>({
  name: 'loader',
  defaults: {
    show: false,
    value: 0,
    mode: 'indeterminate'
  }
})
export class LoaderState {

  constructor() {
  }

  @Selector()
  static show(state: LoaderStateModel) {
    return state.show;
  }

  @Selector()
  static value(state: LoaderStateModel) {
    return state.value;
  }

  @Selector()
  static mode(state: LoaderStateModel) {
    return state.mode;
  }

  @Action(LoaderShow)
  show(ctx: StateContext<LoaderStateModel>, action: LoaderShow) {
    ctx.patchState({
      show: true,
      value: 0,
      mode: action.mode
    });
  }

  @Action(LoaderProgress)
  progress(ctx: StateContext<LoaderStateModel>, action: LoaderProgress) {
    ctx.patchState({
      value: action.value
    });
  }

  @Action(LoaderHide)
  hide(ctx: StateContext<LoaderStateModel>, action: LoaderHide) {
    ctx.patchState({
      show: false,
      value: 0
    });
  }

}
